export var AmountType;
(function (AmountType) {
    AmountType[AmountType["QUANTITY"] = 0] = "QUANTITY";
    AmountType[AmountType["AMOUNT"] = 1] = "AMOUNT";
    AmountType[AmountType["QUANTITY_MIN_PIP"] = 2] = "QUANTITY_MIN_PIP";
    AmountType[AmountType["EXPOSURE"] = 3] = "EXPOSURE";
})(AmountType || (AmountType = {}));
export function deserializeServerLimitsConterainers(serializedServerLimits) {
    if (!isValidString(serializedServerLimits)) {
        return [];
    }
    const serverLimits = JSON.parse(serializedServerLimits);
    if (isNullOrUndefined(serverLimits) || !isValidArray(serverLimits.limits)) {
        return [];
    }
    return serverLimits.limits;
}
